import React from 'react';
import ContentPage from './ContentPage';

// Content now lives in the content_pages table (#66); see ContentPage.js.
function About() {
  return <ContentPage slug="about" title="About" />;
}

export default About;
